export const postMaturityStrategyDescriptions = {
    ROLLOVER: 'Rollover at maturity',
    ROLLBACK: 'Rollback',
    SWITCH: 'Switch'
};
export const getPostMaturityStrategyDescription = (postMaturityStrategy) => postMaturityStrategy ? postMaturityStrategyDescriptions[postMaturityStrategy] : null;
